const ARROW_KEYS = {
  38: 'UP',
  40: 'DOWN',
  37: 'LEFT',
  39: 'RIGHT'
};

export const eventNoopHandler = {
  arrowKeysEventNoop: (e) => {
    const key = e.which || e.keyCode;

    if (ARROW_KEYS[key]) {
      eventNoop(e);
    }
  },
  anyEventNoop: (e) => {
    eventNoop(e);
  }
};

function eventNoop(e) {
  e.preventDefault();
  e.stopPropagation();
}

function daypickerDecorator($provide) {
  function datePickerDirective($delegate) {

    // since: directives could potentially share names, the provider returns an array
    // therefore: get the first item as we know we only have one.
    const directive = $delegate[0];

    // reference the original link function
    const link = directive.link;

    directive.compile = () => {
      return function(scope, element, attrs, controller) {
        let updateMin, updateMax;
        const ctrl = controller[0];

        Reflect.apply(link, this, arguments);

        scope.renderDateRange = false;

        //overrides datepicker.js keydown event
        element.bind('keydown', eventNoopHandler.arrowKeysEventNoop);
        element.bind('click', eventNoopHandler.anyEventNoop);

        //disable navigation according to the range
        scope.daypickerNavPrevDisabled = () => {
          const firstDayOfMonth = new Date(ctrl.activeDate.getFullYear(),
            ctrl.activeDate.getMonth(), 1);
          return ctrl.minDate && firstDayOfMonth <= ctrl.minDate;
        };

        scope.daypickerNavNextDisabled = () => {
          // calculate last day of month by using the 0th day trick:
          // if values are greater/lesser than their logical range,
          // the adjacent value will be adjusted.
          const lastDayOfMonth =
            new Date(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth() + 1, 0);
          return ctrl.maxDate && lastDayOfMonth >= ctrl.maxDate;
        };

        updateMax = scope.$on('datepicker.updateMaxDate', (e, info) => {
          ctrl.maxDate = info.maxDate;
          if (info.reset || ctrl.activeDate.getTime() > ctrl.maxDate.getTime()) {
            ctrl.activeDate = info.selectedDate || new Date();
          }
          ctrl.refreshView();
        });

        updateMin = scope.$on('datepicker.updateMinDate', (e, info) => {
          ctrl.minDate = info.minDate;
          if (info.reset || ctrl.activeDate.getTime() < ctrl.minDate.getTime()) {
            ctrl.activeDate = info.selectedDate || new Date();
          }
          ctrl.refreshView();
        });

        scope.$on('$destroy', () => {
          updateMin();
          updateMax();
          element.off('keydown');
          element.off('click');
        });
      };
    };
    return $delegate;
  }

  datePickerDirective.$inject = ['$delegate'];
  $provide.decorator('uibDaypickerDirective', datePickerDirective);
}

daypickerDecorator.$inject = ['$provide'];
export default daypickerDecorator;
